<template>
  <div class="shinework-page">
    <div class="shinework-header">
      <div class="header-title">{{ title }}</div>
      <div class="header-right" @click="copyContent($event)">
        <span class="copy-btn">复制</span>
      </div>
    </div>
    <div class="shinework-content">
      <VueMarkdown :source="markdownContent" class="markdown-body"></VueMarkdown>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import { Notify } from 'vant'
import { handleClipboard } from '../../assets/js/clipboard'
import { getShineWorkResult } from '@/api/shinework'

var mockMarkdown = ''

export default {
  name: 'shinework',
  components: { VueMarkdown },
  data() {
    return {
      title: '亮点工作',
      markdownContent: mockMarkdown
    }
  },
  mounted() {
    let query = this.$route.query
    let id = query.id || ''
    if (id) {
      this.queryData(id)
    }
  },
  methods: {
    goback() {
      window.history.go(-1)
    },
    queryData(id) {
      getShineWorkResult({ sessionId: id }).then(res => {
        if (res.data && res.data.code === 200) {
          let data = res.data.data
          this.markdownContent = data.result || this.markdownContent
          if (data.jobName) {
            this.title = data.jobName
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    copyContent(event) {
      handleClipboard(this.markdownContent, event, () => {
        Notify({
          message: '复制成功',
          duration: 1000,
          className: 'notifyNew'
        })
      }, () => {
        Notify({
          message: '复制失败',
          duration: 1000,
          className: 'notifyErr'
        })
      })
    }
  }
}
</script>

<style scoped>
.shinework-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f6fa;
}
.shinework-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  height: 88px;
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 0 30px;
}
.header-title {
  flex: 1;
  text-align: center;
  font-size: 34px;
  font-weight: 500;
  color: #333;
}
.header-right {
  width: 60px;
  text-align: right;
}
.copy-btn {
  font-size: 26px;
  color: #1677ff;
}
.shinework-content {
  padding: 108px 0 30px;
}
</style>
<style>
.shinework-page .markdown-body {
  background: #fff;
  padding: 30px;
  font-size: 28px;
  line-height: 1.8;
  color: #333;
  word-break: break-word;
}
.shinework-page .markdown-body h1 {
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.shinework-page .markdown-body h2 {
  font-size: 34px;
  font-weight: 600;
  color: #333;
  margin: 40px 0 20px;
}
.shinework-page .markdown-body h3 {
  font-size: 30px;
  font-weight: 600;
  color: #444;
  margin: 30px 0 16px;
}
.shinework-page .markdown-body p {
  margin: 16px 0;
  font-size: 28px;
  line-height: 1.8;
}
.shinework-page .markdown-body ul,
.shinework-page .markdown-body ol {
  padding-left: 40px;
  margin: 16px 0;
}
.shinework-page .markdown-body li {
  margin: 10px 0;
  font-size: 28px;
  line-height: 1.7;
}
.shinework-page .markdown-body strong {
  color: #1677ff;
  font-weight: 600;
}
.shinework-page .markdown-body blockquote {
  margin: 20px 0;
  padding: 20px 24px;
  background: #f0f7ff;
  border-left: 6px solid #1677ff;
  border-radius: 0 8px 8px 0;
  font-size: 26px;
  color: #555;
}
.shinework-page .markdown-body table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 24px;
}
.shinework-page .markdown-body th,
.shinework-page .markdown-body td {
  border: 1px solid #e8e8e8;
  padding: 16px 12px;
  text-align: left;
}
.shinework-page .markdown-body th {
  background: #f5f7fa;
  font-weight: 600;
  color: #333;
}
.shinework-page .markdown-body tr:nth-child(even) {
  background: #fafbfc;
}
.shinework-page .markdown-body code {
  background: #f5f5f5;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 24px;
  color: #e83e8c;
}
.shinework-page .markdown-body pre {
  background: #282c34;
  color: #abb2bf;
  padding: 24px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 20px 0;
  font-size: 24px;
  line-height: 1.6;
}
.shinework-page .markdown-body pre code {
  background: none;
  color: inherit;
  padding: 0;
}
.shinework-page .markdown-body hr {
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 30px 0;
}
.shinework-page .markdown-body em {
  color: #999;
  font-size: 24px;
}
</style>
